<template>
  <div class="c-audio">
    <button
      class="c-audio__control"
      :class="{ 'c-audio__control--active': playing }"
      role="button"
      :aria-label="playing ? 'Pause' : 'Play'"
      @click="toggleAudio"
    >
      <PlayAnimation v-if="!playing" />
      <PauseAnimation v-if="playing" />
    </button>

    <p class="c-audio__title">Listen</p>
    <p class="c-audio__text">{{ text }}</p>
    <audio>
      <source :src="src" type="audio/mp3" />
      Your browser does not support the audio element.
    </audio>
  </div>
</template>

<script>
import PlayAnimation from "@/components/animations/PlayAnimation.vue";
import PauseAnimation from "@/components/animations/PauseAnimation.vue";

export default {
  props: ["id", "text"],
  computed: {
    src() {
      return `content/${this.id}/voiceover.mp3`;
    },
  },
  components: {
    PlayAnimation,
    PauseAnimation,
  },
  data() {
    return {
      playing: false,
    };
  },
  methods: {
    toggleAudio() {
      this.playing = !this.playing;
      const audioPlayer = document.querySelector(".c-audio audio");
      if (this.playing == true) {
        audioPlayer.play();
      } else {
        audioPlayer.pause();
      }
    },
  },
};
</script>
